import { ArrowForward } from "@mui/icons-material";
import React from "react";
import { useNavigate } from "react-router-dom";

const RPACta = () => {
  const navigate = useNavigate();
  return (
    <section className="bg-[#eff6e7] py-16 px-6 md:px-12 lg:px-24">
      <div className="max-w-[1440px] mx-auto">
        <div className="bg-[#00450d] border border-white/20 rounded-[32px] overflow-hidden px-8 md:px-20 py-16 md:py-20 flex flex-col items-center text-center gap-8 relative">
          {/* Decorative Gradient/Light Effect */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#38c443] opacity-10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#38c443] opacity-5 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/2"></div>

          <div className="flex flex-col gap-4 z-10">
            <h2 className="text-white text-4xl md:text-5xl lg:text-6xl font-extrabold manrope leading-tight max-w-[850px]">
              Ready to Orchestrate Your Future?
            </h2>
            <p className="text-white/80 text-lg md:text-xl inter max-w-[700px] mx-auto leading-relaxed">
              Join the world's most innovative enterprises using Teja
              Technologies to power their cognitive evolution.
            </p>
          </div>

          <div className="pt-4 z-10">
            <button
              onClick={() => navigate("/contact-us")}
              className="text-white  hover:text-black group relative flex items-center gap-4 bg-transparent border-2 border-white/30 rounded-full pl-8 pr-3 py-3 hover:bg-[#f7e14d] hover:border-[#f7e14d] hover:text-black hover:bg-white/5 transition-all active:scale-95"
            >
              <span className=" text-lg font-semibold inter">
                Talk to an Expert
              </span>
              <div className="bg-[#f7e14d] group-hover:bg-[#00450d] w-12 h-12 rounded-full flex items-center justify-center transition-transform group-hover:rotate-45">
                <ArrowForward className="text-black group-hover:text-white transition-colors" />
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RPACta;
